import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { SignUpOperatorFormData } from "../types";

export const WebsiteAddressField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SignUpOperatorFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">What is your web address / website URL?</Typography>
      <TextInput
        className="w-full"
        hasError={!!errors.websiteAddress}
        placeholder="Enter Website Address"
        maxLength={128}
        {...register("websiteAddress")}
      />
      <Typography variant="small" className="text-neutral-dark-gray">
        Optional
      </Typography>
      <ErrorMessage errors={errors} name="websiteAddress" />
    </div>
  );
};
